// Features/Misc/Dispatch.ts
var html = document.documentElement;
function dispatchEvent(name, detail) {
  const init = { detail, bubbles: true };
  const event = new CustomEvent(name, init);
  html.dispatchEvent(event);
}
function dispatchOn(element, name, detail) {
  const init = {
    cancelable: true,
    bubbles: true,
    detail
  };
  const event = new CustomEvent(name, init);
  element.dispatchEvent(event);
}
function dispatchCartRefresh(detail) {
  dispatchEvent("Cart:Refresh", detail);
}
function dispatchCartChange(detail) {
  dispatchEvent("Cart:Changed", detail);
}
function dispatchShowCartNote(element, detail) {
  dispatchOn(element, "cart-notification:show", detail);
}
// Features/Misc/Section.ts
function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (domElement.getAttribute("section") === event.detail.sectionId)
      executeCallback = true;
  } else if (event.type.includes("shopify:block") && event.target === domElement)
    executeCallback = true;
  if (executeCallback)
    callback(event);
}
// Features/Misc/Event.ts
function triggerEvent(element, name, data = {}) {
  const event = new CustomEvent(name, {
    bubbles: true,
    detail: data
  });
  element.dispatchEvent(event);
}
function triggerNonBubblingEvent(element, name, data = {}) {
  const event = new CustomEvent(name, {
    bubbles: false,
    detail: data
  });
  element.dispatchEvent(event);
}
// Features/Misc/Media.ts
class MediaFeatures {
  static prefersReducedMotion() {
    return window.matchMedia(`( prefers-reduced-motion : reduce )`).matches;
  }
  static supportsHover() {
    return window.matchMedia(`( pointer : fine )`).matches;
  }
}
export {
  triggerNonBubblingEvent,
  triggerEvent,
  filterShopifyEvent,
  dispatchShowCartNote,
  dispatchCartRefresh,
  dispatchCartChange,
  MediaFeatures
};
